import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="content">
    <div class="error">
      <img alt="CUE Audio" class="error__img" src="assets/site/media/img/logo/CUE_logo_main_white-01.png">
      <div class="error__details">
        <h3 class="error__title">Whoops! Sorry about this.</h3>
        <h4 class="error__subtitle">We can't seem to find the page you're looking for.</h4>
        <a class="error__button" routerLink="/portal">Back to Homepage</a>
      </div>
    </div>
    </div>
  `,
  styles: [`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .content {
    background-color: #060606;
  }

  .error {
    align-items: center;
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
  }

  .error__img {
    height: 249px;
    position: absolute;
    top: 1.75rem;
    width: auto;
  }

  .error__details {
    margin-top: 3rem;
  }

  .error__title {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 1rem;
    text-align: center;
  }

  .error__subtitle {
    color: #777;
    font-family: "Avenir Next",sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 3rem;
    text-align: center;
  }

  .error__button {
    background-color: transparent;
    box-shadow: inset 0 0 0 1px #fff;
    border-radius: 4px;
    border-color: transparent;
    color: #fff;
    cursor: pointer;
    display: block;
    font-family: "Avenir Next",sans-serif;
    font-size: 14px;
    font-weight: 500;
    min-height: 50px;
    line-height: 50px;
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
    outline: 0;
    padding-top: 1px;
    text-align: center;
    text-transform: uppercase;
    transition: box-shadow .15s linear,color .15s linear;
    vertical-align: middle;
    width: 200px;
  }
  `]
})

export class NotFoundComponent { }
